// extracted by mini-css-extract-plugin
export default {"container":"ViewPanel_container__pgLMX","list":"ViewPanel_list__AB8Zd"};